import React, { useCallback } from "react"
import { CategoriesListBall, CategoriesListContainer } from "../../styled"

const useCategoryList = () => {
  const getCategories = useCallback(categories => {
    const categoriesList = categories.split(",")
    const elements = []

    categoriesList.forEach((category, index) => {
      elements.push(
        <>
          {category}
          {index !== categoriesList.length - 1 && (
            <CategoriesListBall key={index} />
          )}
        </>
      )
    })

    return <CategoriesListContainer>{elements}</CategoriesListContainer>
  }, [])

  return { getCategories }
}

export default useCategoryList
